import React, { useContext } from 'react';
import styles from './ZavrsniRadoviPagination.module.css';
import { ReactComponent as PaginationArrowRight } from '../assets/pagination-arrow-right.svg';
import { ReactComponent as PaginationArrowLeft } from '../assets/pagination-arrow-left.svg';
import { ThemeContext } from '../contexts/ThemeContext';
import PropTypes from 'prop-types';

const ZavrsniRadoviPagination = ({prikazOffset, prikazSize, ukupanBrojRadova,
showNextPage, showPreviousPage}) => {
  const { dark } = useContext(ThemeContext);
  let prikazUpperLimit = prikazOffset + prikazSize;
  let ukupnoRadova = ukupanBrojRadova;

  return (
    <div className={styles.zavrsniRadoviPaginationContainer}>
      {((ukupnoRadova = ukupnoRadova || 0) === 0 ? 0 : prikazOffset + 1) + " - " + (prikazUpperLimit = prikazUpperLimit || 0) + " od " + (ukupnoRadova = ukupnoRadova || 0)}
      {prikazOffset > 0 ?
        <PaginationArrowLeft
          className={dark ? styles.paginationArrowIconDark : styles.paginationArrowIconLight}
          onClick={showPreviousPage} /> : null}
      {(prikazUpperLimit = prikazUpperLimit || 0) < (ukupnoRadova = ukupnoRadova || 0) ?
        <PaginationArrowRight
          className={dark ? styles.paginationArrowIconDark : styles.paginationArrowIconLight}
          onClick={showNextPage} /> : null}
    </div>
  );
}

ZavrsniRadoviPagination.propTypes = {
  ukupanBrojRadova: PropTypes.number,
  prikazOffset: PropTypes.number,
  prikazSize: PropTypes.number,
  showPreviousPage: PropTypes.func,
  showNextPage: PropTypes.func
};

export default ZavrsniRadoviPagination;